export const BILL_TYPE = {
    // DEPOSIT: '充值',
    // WITHDRAW: '提现',
    // CANCEL_WITHDRAW: '取消提现',
    // CREATE_TRADE: '交易下单',
    // CANCEL_TRADE: '交易撤单',
    // TRADE_DEAL: '交易撮合',
    // C2C_PLACE_ORDER: 'C2C交易下单',
    // C2C_PROCESS_ORDER: 'C2C成交',
    // WORLDCUP_DEPOSIT: '世界杯充值',
    // WORLDCUP_WITHDRAW: '世界杯提现',
    // OTC_ORDER_TRANSFER: 'OTC转账',
    // OTC_ORDER_FROZEN: 'OTC下单',
    // OTC_ORDER_CANCEL: 'OTC取消',
    // OTC_ADVERTISING_PUTAWAY: 'OTC广告上架',
    // OTC_ADVERTISING_SOLD_OUT: 'OTC广告下架'


    DEPOSIT: '充值',
    WITHDRAW: '提现',
    ALLIANCE: '链上资产',
    PURCHASE: '申购',
    CREATE_TRADE: '交易下单',
    CANCEL_TRADE: '交易撤单',
    TRADE_DEAL: '交易撮合',
    OTC_ORDER_TRANSFER: 'OTC转账',
    OTC_ORDER_FROZEN: 'OTC下单',
    OTC_ORDER_CANCEL: 'OTC取消',
    OTC_ADVERTISING_PUTAWAY: 'OTC广告上架',
    OTC_ADVERTISING_SOLD_OUT: 'OTC广告下架',
    MINING_BKK: '挖矿',
    MINING_SHARE: '分红',
    MINING_AIR_DROP: '空投',
    BKK_BONUS_ON_DEAL: 'BKK交易奖励',
    RED_PACKET_TRANSFER: '新春红包转账',
    TRIBE: '部落',
    PLEDGE: '活期宝',
    REGULAR_DEPOSIT: '定期宝',
    TRANSFER_IN: '转入',
    TRANSFER_OUT: '转出',
    REWARD: '奖励',
    COUPON: '卡券',
    MOETGAGE: '借贷宝',
    FEE: '合约手续费',
    FEE_SHARE: '手续费分红',
    PNL: '盈亏',
    CONTRACT_GENERAL_OPEN: '超级合约开仓',
    CONTRACT_GENERAL_STOP_LIMIT_CANCEL: '超级合约计划委托撤销',
    HASHRATE: '云算力认购',
    FUND_SUBSCRIBE: '基金认购',
    RED_ENVELOPE: '红包',
    CURRENT_MINING: '活期宝挖矿',
    INTERNAL_DEPOSIT: '内部转账-充值',
    INTERNAL_WITHDRAW: '内部转账-提现',
    USERMINING: '挖矿宝',
    STAKING: 'STAKING',
    COIN_EXCHANGE: '币种兑换',
    STRATEGY_SUBSCRIBE: '策略订阅',
    OTHER: '其它',
    BUY_ORDER_FROZEN:"七折抢购冻结资金",
    BUY_ORDER_UNFROZEN:"七折抢购解冻资金",
    TRADE_MINING_PRIZE: "交易挖矿",
    RANDOM_FREE_PRIZE: "随机免单",
    HTC_PRIZE:"HTC奖励",
    HTC_CONSUMER: "HTC消耗",
    HASH_LOTTERY: "HASH夺宝",
    STOCK_HOLD_REWARD: "股权分红"
};
